import ToolsTab from './ToolsTab';

export default ToolsTab;
